/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Cap_ContinueInputs */



/**
* | output |
* | --- |
* | "Keep recording" |
*
* @param {Meeting_Offline_Cap_ContinueInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_cap_continue = /** @type {((inputs?: Meeting_Offline_Cap_ContinueInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Cap_ContinueInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verder opnemen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer d'enregistrer")
	return /** @type {LocalizedString} */ ("Keep recording")
});